import { useTypeSafeMutation, ValidatePhoneBody } from '@oresundsbron/api';
import { pipe } from 'fp-ts/lib/function';
import { fold, tryCatch, fromTask } from 'fp-ts/lib/TaskOption';
import { of } from 'fp-ts/lib/Task';
import { useCallback } from 'react';
import { ValidationResult } from '@oresundsbron/use-form';
import { decodePhoneCode } from '~/lib/phone-code';

export function useValidatePhone() {
  const { mutateAsync } = useTypeSafeMutation(
    ['phone', 'validate'],
    (req) => req.Phone.validate
  );

  const validate = useCallback(
    <T>(validationResult: ValidationResult<T>) =>
      (body: ValidatePhoneBody) =>
        pipe(
          tryCatch(() =>
            mutateAsync({
              ...body,
              phoneCode: decodePhoneCode(body.phoneCode),
            })
          ),
          fold(
            () => of(validationResult),
            () => of(undefined)
          ),
          fromTask
        ),
    [mutateAsync]
  );

  return validate;
}
